import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type HomeTranslations = {
  [lang: string]: Translation;
};

export const homeTranslations: HomeTranslations = {
  en,
};
